
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/security-privacy",
      function () {
        return require("private-next-pages/security-privacy.tsx");
      }
    ]);
  